/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgExpandAll = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m11.93 4.866 5.169 5.17 1.292-1.293-5.17-5.169c-1.291-1.292-2.583 0-2.583 0l-5.17 5.17 1.293 1.291zM11.93 19.134l-5.169-5.17-1.292 1.293 5.169 5.169c1.292 1.292 2.584 0 2.584 0l5.169-5.17-1.292-1.291z" /></svg>;
export default SvgExpandAll;